import { render, staticRenderFns } from "./loadingIndex.vue?vue&type=template&id=80b613b0"
import script from "./loadingIndex.vue?vue&type=script&lang=js"
export * from "./loadingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports